export const SE_MISSING_PERSONA_INFO_NAV_TREE = {
  label: 'SeMissingPersonaInfo',
  key: 'se-missing-persona-info',
  attributes: { href: '/docs/se-missing-persona-info' }
}
